function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import MuiPagination from "@mui/material/Pagination";
function PaginationActions({ page, onPageChange, count, rowsPerPage, className }) {
    // Enable server-side pagination by setting count to -1
    // https://mui.com/material-ui/api/table-pagination/#table-pagination-prop-count
    const numberOfPages = count !== -1 ? Math.ceil(count / rowsPerPage) : -1;
    return /*#__PURE__*/ _jsx(MuiPagination, {
        className: className,
        count: numberOfPages,
        // Offset page to convert from 0-based indexing of TablePagination to 1-based indexing of Pagination
        page: page + 1,
        onChange: (event, newPage)=>{
            onPageChange(event, newPage - 1);
        }
    });
}
/**
 * @see https://www.figma.com/design/Tb6GgTuIDhCTiA132VuYT5/Ignite-Riddle?node-id=9848-291434
 * @see https://mui.com/material-ui/react-pagination/#table-pagination
 */ export const TablePagination = {
    MuiTablePagination: {
        defaultProps: {
            ActionsComponent: PaginationActions,
            slotProps: {
                select: {
                    variant: "outlined",
                    size: "medium"
                }
            }
        },
        styleOverrides: {
            selectLabel: ({ theme })=>_object_spread_props(_object_spread({}, theme.typography.textSm), {
                    color: theme.palette.text.textPlaceholder
                }),
            selectRoot: {
                minWidth: 80,
                marginLeft: 12,
                marginRight: 12
            },
            actions: ({ theme })=>({
                    paddingLeft: theme.spacing(6),
                    paddingRight: theme.spacing(6)
                })
        }
    }
};

//# sourceMappingURL=TablePagination.js.map